/** 引入Vue 库 */
import Vue from 'vue'

/** 引入index.vue */
import IndexVue from "./pages/index"

/** 引入路由配置文件 */
import router from './router/index'

/** 引入element-ui文件并注册 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

/** 控制权限方法 */
import { calcBtnShow, mzConfirm, GetLocalQxData, PageQxData, setDataCons } from './utils/Tool';
Vue.prototype.mzConfirm = mzConfirm;             //  再次确认弹窗

/** 全局组件 */
import global from './components/index';
Vue.use(global)

/** 引入apis */
import Api from './api/index'
Vue.prototype.$Api = Api

// import '@/assets/icon/iconfont.css'
/** 引入index.less */
import '@/styles/main'

import "default-passive-events"; //添加事件管理者'passive'，来阻止'touchstart'事件，让页面更加流畅。 解决chrome下的warning问题
/** 引入时间库 */
import moment from "moment"; 
Vue.prototype.moment = moment
// 动态显示实时时间/时间格式化插件
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs; 

var baseUrl = 'https://ai.kbsdkj.cn'
Vue.prototype.$baseUrl = baseUrl

var wsUrl = 'wss://ai.kbsdkj.cn'
Vue.prototype.$wsUrl = wsUrl

new Vue({
    el: '#app', 
    render(createElement) {
        let layout = this.$route.meta.layout
        layout = layout ? layout : this.$route.path === '/' ? '' : 'main-layout';
        return createElement(IndexVue, {props: {layout}})
    },
    router,
})

